
export enum CheckoutStatusEnum {
    Pending = -1,
    Success = 0,
    Failed = 1,
    Rejected = 2,
    Secure3DAuth = 3
}

export interface IGiftCardCheckoutResult {
    checkoutStatus: CheckoutStatusEnum;
    statusMessage: string;
    thankYouPageUrl: string;
    secure3DAuth: ICheckout3DAuth;
}

export interface ICheckout3DAuth {
    acsUrl: string;
    creq: string;
    transactionid: string;
}